export default [
  {
    title: 'Relatórios',
    icon: 'FileTextIcon',
    action: 'read',
    resource: 'Relatorios',
    children: [
      {
        title: 'Relatório de Comissões',
        route: 'relatorio-comissoes',
        action: 'read',
        resource: 'RelatorioComissoes',
      },
    ],
  },
];
